import type { FeatureFlags } from '#types/featureFlags'

// We assume the config is always available after the app started.
export default () => toReactive(useState('featureFlags', () => ({} as FeatureFlags)))

export const useLocalFeatureFlags = () => useState<Partial<FeatureFlags>>('localFeatureFlags')

export const useFeatureFlagsPassthroughHeader = () => useState('featureFlagsPassthroughHeader', () => '')

export const useActiveExperiments = () => toReactive(useState('activeExperiments', () => ({ evaluated: false, active: false })))

export const useExperiments = () =>
  toReactive(useState('experiments', () => ({} as Partial<{ [key in keyof FeatureFlags]: any }>)))

export const useEdgeWorkerExperiments = () => useState('edgeWorkerExperiments', () => ({} as Partial<FeatureFlags>))
